module.exports = __webpack_public_path__ + "static/media/drone.6f9a9a49.svg";